module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "tax_form"
    }
  }, [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "type": "success"
    },
    model: {
      value: (_vm.alertStatus),
      callback: function($$v) {
        _vm.alertStatus = $$v
      },
      expression: "alertStatus"
    }
  }, [_vm._v("We have recieved your tax exemption. Upon verification your status will be updated.")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    attrs: {
      "append-icon": "edit",
      "counter": 20,
      "error-messages": _vm.errors.collect('busname'),
      "data-vv-name": "busname",
      "required": "",
      "label": "Business Name"
    },
    model: {
      value: (_vm.data.busName),
      callback: function($$v) {
        _vm.$set(_vm.data, "busName", $$v)
      },
      expression: "data.busName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-select', {
    ref: "type",
    attrs: {
      "items": _vm.exemptionList,
      "hint": 'Government',
      "label": "Exemption Type",
      "append-icon-cb": _vm.closeType
    },
    model: {
      value: (_vm.data.exemption),
      callback: function($$v) {
        _vm.$set(_vm.data, "exemption", $$v)
      },
      expression: "data.exemption"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": true,
      "row": ""
    },
    model: {
      value: (_vm.data.cover),
      callback: function($$v) {
        _vm.$set(_vm.data, "cover", $$v)
      },
      expression: "data.cover"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Covers State",
      "value": "state"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Covers Nation",
      "value": "nation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Hold Order, mailing tax exemption form"
    },
    model: {
      value: (_vm.data.hold),
      callback: function($$v) {
        _vm.$set(_vm.data, "hold", $$v)
      },
      expression: "data.hold"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "href": _vm.download,
      "target": "_blank",
      "flat": ""
    }
  }, [_c('img', {
    staticClass: "download_icon",
    attrs: {
      "src": _vm.icon,
      "alt": ""
    }
  }), _vm._v("\n        Download tax exemption Certificate form")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('vue-uppy-cloudinary', {
    attrs: {
      "preset": "reqe2pqu",
      "cloudName": "kencove",
      "allowedFileTypes": _vm.allowedFileTypes
    },
    on: {
      "uploaded": _vm.uploaded
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-btn', {
    staticClass: "submit",
    on: {
      "click": _vm.submitForm3
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [(_vm.attachments.length != 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('h3', [_vm._v("Upload Files:")]), _vm._v(" "), _vm._l((_vm.attachments), function(item) {
    return _c('ul', {
      key: item.etag
    }, [_c('li', [_vm._v(_vm._s(item.original_filename))])])
  })], 2) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70d5304e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tax_exemption_form.vue
// module id = 97
// module chunks = 2